import { render, staticRenderFns } from "./modalRemisionPerfil.vue?vue&type=template&id=cd5e28cc&"
import script from "./modalRemisionPerfil.vue?vue&type=script&lang=js&"
export * from "./modalRemisionPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports